import React from "react";
import OrganizationProfile from "../template/OrganizationProfile";

export default () => <OrganizationProfile />;
